var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExclamationCircleMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 19.9708C13.6285 19.9708 13.2724 19.8233 13.0099 19.5608C12.7473 19.2982 12.5998 18.9421 12.5998 18.5708C12.5998 18.1995 12.7473 17.8434 13.0099 17.5809C13.2724 17.3183 13.6285 17.1708 13.9998 17.1708C14.3711 17.1708 14.7272 17.3183 14.9898 17.5809C15.2523 17.8434 15.3998 18.1995 15.3998 18.5708C15.3998 18.9421 15.2523 19.2982 14.9898 19.5608C14.7272 19.8233 14.3711 19.9708 13.9998 19.9708ZM12.8332 8.49667C12.8332 8.18725 12.9561 7.89051 13.1749 7.67171C13.3937 7.45292 13.6904 7.33 13.9998 7.33C14.3093 7.33 14.606 7.45292 14.8248 7.67171C15.0436 7.89051 15.1665 8.18725 15.1665 8.49667V14.33C15.1665 14.6394 15.0436 14.9362 14.8248 15.155C14.606 15.3738 14.3093 15.4967 13.9998 15.4967C13.6904 15.4967 13.3937 15.3738 13.1749 15.155C12.9561 14.9362 12.8332 14.6394 12.8332 14.33V8.49667ZM13.9998 1.1665C6.91234 1.1665 1.1665 6.91234 1.1665 13.9998C1.1665 21.0885 6.91234 26.8332 13.9998 26.8332C21.0873 26.8332 26.8332 21.0885 26.8332 13.9998C26.8332 6.91234 21.0873 1.1665 13.9998 1.1665Z",
    fill: "#FF6363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationCircleMono);
export default __webpack_public_path__ + "static/media/icon_exclamation_circle_mono.bf7658c8e7edc2ef0dd3685c616dc538.svg";
export { ForwardRef as ReactComponent };